import React, { useState } from "react";
import { FaArrowRight, FaHandsHelping } from "react-icons/fa";
import "./ConnectionCard.css";
import Footer from "./Footer";

const ACCESS_KEY = "00bb38f1-38dc-4c70-b5ef-0867572bd0da";
const REDIRECT_URL = "https://thecitychurchluzira.churchcenter.com/people/forms/937756";

const GUEST_TYPES = ["1st Time Guest", "2nd Time Guest", "Regular Attendee", "Member"];
const INTERESTS = ["Baptism", "Serving at Church", "City Leadership Institute", "City Finance SACCO"];

const EMPTY = {
  name: "", email: "", residence: "", occupation: "", tel: "",
  guestType: "", interest: [], prayerRequest: "",
};

const ConnectionCard = () => {
  const [formData, setFormData] = useState(EMPTY);
  const [status, setStatus] = useState({ state: "idle", message: "" });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        interest: checked
          ? [...prev.interest, value]
          : prev.interest.filter((item) => item !== value),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: "submitting", message: "" });

    const dataToSend = new FormData();
    dataToSend.append("access_key", ACCESS_KEY);
    dataToSend.append("subject", "Connection Card Submission");
    dataToSend.append("name", formData.name);
    dataToSend.append("email", formData.email);
    dataToSend.append("residence", formData.residence);
    dataToSend.append("occupation", formData.occupation);
    dataToSend.append("tel", formData.tel);
    dataToSend.append("guestType", formData.guestType);
    dataToSend.append("interest", formData.interest.join(", "));
    dataToSend.append("prayerRequest", formData.prayerRequest);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: dataToSend,
      });
      const result = await response.json();
      if (result.success) {
        setStatus({ state: "success", message: "Thank you! Your card has been received. Redirecting you now." });
        setFormData(EMPTY);
        setTimeout(() => { window.location.href = REDIRECT_URL; }, 1200);
      } else {
        setStatus({ state: "error", message: "Something went wrong submitting your card. Please try again." });
      }
    } catch (error) {
      setStatus({ state: "error", message: "A network error occurred. Please try again." });
    }
  };

  const submitting = status.state === "submitting";

  return (
    <div>
      {/* HERO */}
      <header className="cc-hero">
        <div className="tcc-container cc-hero__inner">
          <span className="cc-hero__badge"><FaHandsHelping aria-hidden="true" /></span>
          <p className="tcc-eyebrow cc-hero__eyebrow">Let&rsquo;s stay connected</p>
          <h1 className="cc-hero__title">Connection card</h1>
          <p className="cc-hero__lead">
            New here or ready to get more involved? Fill this out so we know you were with
            us and can help you take your next step.
          </p>
        </div>
      </header>

      {/* FORM */}
      <section className="tcc-section cc-form-section">
        <div className="tcc-container cc-form-wrap">
          <form className="cc-form tcc-card" onSubmit={handleSubmit} noValidate>
            {status.state === "success" && (
              <div className="tcc-alert tcc-alert--success" role="status">{status.message}</div>
            )}
            {status.state === "error" && (
              <div className="tcc-alert tcc-alert--error" role="alert">{status.message}</div>
            )}

            <div className="cc-grid">
              <div className="tcc-field">
                <label className="tcc-label" htmlFor="cc-name">Name</label>
                <input className="tcc-input" id="cc-name" type="text" name="name" required
                  value={formData.name} onChange={handleChange} autoComplete="name" />
              </div>
              <div className="tcc-field">
                <label className="tcc-label" htmlFor="cc-email">Email</label>
                <input className="tcc-input" id="cc-email" type="email" name="email" required
                  value={formData.email} onChange={handleChange} autoComplete="email" />
              </div>
              <div className="tcc-field">
                <label className="tcc-label" htmlFor="cc-tel">Telephone</label>
                <input className="tcc-input" id="cc-tel" type="tel" name="tel" required
                  value={formData.tel} onChange={handleChange} autoComplete="tel" />
              </div>
              <div className="tcc-field">
                <label className="tcc-label" htmlFor="cc-residence">Residence</label>
                <input className="tcc-input" id="cc-residence" type="text" name="residence" required
                  value={formData.residence} onChange={handleChange} />
              </div>
              <div className="tcc-field cc-field--full">
                <label className="tcc-label" htmlFor="cc-occupation">Occupation</label>
                <input className="tcc-input" id="cc-occupation" type="text" name="occupation" required
                  value={formData.occupation} onChange={handleChange} />
              </div>
            </div>

            <fieldset className="cc-fieldset">
              <legend className="tcc-label cc-legend">Are you a</legend>
              <div className="cc-options">
                {GUEST_TYPES.map((g) => (
                  <label className={`cc-option ${formData.guestType === g ? "is-selected" : ""}`} key={g}>
                    <input type="radio" name="guestType" value={g} required
                      checked={formData.guestType === g} onChange={handleChange} />
                    <span>{g}</span>
                  </label>
                ))}
              </div>
            </fieldset>

            <fieldset className="cc-fieldset">
              <legend className="tcc-label cc-legend">I am interested in <span className="tcc-optional">(optional)</span></legend>
              <div className="cc-options">
                {INTERESTS.map((i) => (
                  <label className={`cc-option ${formData.interest.includes(i) ? "is-selected" : ""}`} key={i}>
                    <input type="checkbox" name="interest" value={i}
                      checked={formData.interest.includes(i)} onChange={handleChange} />
                    <span>{i}</span>
                  </label>
                ))}
              </div>
            </fieldset>

            <div className="tcc-field">
              <label className="tcc-label" htmlFor="cc-prayer">Prayer request <span className="tcc-optional">(optional)</span></label>
              <textarea className="tcc-textarea" id="cc-prayer" name="prayerRequest"
                placeholder="Share anything you would like us to pray for."
                value={formData.prayerRequest} onChange={handleChange} />
            </div>

            <button className="tcc-btn tcc-btn--accent tcc-btn--lg tcc-btn--block" type="submit" disabled={submitting}>
              {submitting ? "Submitting..." : (<>Submit card <FaArrowRight aria-hidden="true" /></>)}
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ConnectionCard;
